/**
 * 封装 axios 请求模块
 * 接口开头全部小写
 * 增 add**
 * 删 delete**
 * 改 updata**
 * 查 get**
 */
import axios from "axios"
import common from "../assets/common"
import store from '../store/index'  
import router from '../router/index' 
import { MessageBox } from 'element-ui';

// sessionStorage.setItem('baseUrl','https://dms.bendamoto.com/bendaFDMSWeb/')
sessionStorage.setItem('baseUrl','https://fdms-test.bendamotor.cn/bendaFDMSTestWeb/')

// sessionStorage.setItem('baseUrl','https://dms-de.bendamoto.com/bendaFDMSWeb/')   // 德国
// sessionStorage.setItem('baseUrl','http://hnlzwaq.eicp.net/')//测试本地/

axios.defaults.headers['content-type'] = 'application/json'; 
 const request = axios.create({ 
  //  baseURL:'http://hnlzwaq.eicp.net/'//测试本地
    baseURL:'https://fdms-test.bendamotor.cn/bendaFDMSTestWeb/',
    // baseURL:'https://dms.bendamoto.com/bendaFDMSWeb/',
    // baseURL:'https://dms-de.bendamoto.com/bendaFDMSWeb/',
      // baseURL:'/bendaFDMSWeb',
    // baseURL:' http://192.168.0.7:8081/',
 }) 
 


//  axios.interception.request.user(config => {
//   config.headers.Authorization = window.sessionStorage.getItem('token')
//   return config
// })
 // request拦截器
 request.interceptors.request.use(config => {
//接口携带token


config.headers['Authorization'] =  window.sessionStorage.getItem('token') 
  if (common.getItem('token')) {
  
  }
  return config
}, error => {
  Promise.reject(error)
})

let flag = 0
request.interceptors.response.use( response => {
  const code = response.data.code || 200
  const dee = response.data.error 
  store.commit('setToken',response.headers['new-token'])
  if(dee==false){
    flag++
    
    if(flag == 1){
     // debugger
 
     MessageBox('Your login status has expired. Please log in again.', 'Tips', {
       confirmButtonText: 'Confirm',
       type: 'warning'
      
     }).then(() => {
      // window.location.href = 'http://fdms-dealer-test.bendamotor.cn/#/token'
       router.replace({
         path:'/login'
       })
      flag = 0
 
       return response;
     }).catch(err => {});
   }    
   
    
    // axios.get('http://fdms-test.bendamotor.cn/bendaFDMSTestWeb/token',
    //   {
    //     'headers': {
    //       'authorization': sessionStorage.getItem('token')
    //     }
    //   })
    //   .then(async res => {
    //     sessionStorage.setItem('token',res.token)
    //   })
   }

  if (code == 401) {
    flag++
    
   if(flag == 1){
    // debugger

    MessageBox('Your login status has expired. Please log in again.', 'Tips',{
      confirmButtonText: 'Confirm',
      type: 'warning'
     
    }).then(() => {
   
      router.replace({
        path:'/login'
      })
     flag = 0

      return response;
    }).catch(err => {});
  }    
  
  
  }else {
    return response;
  }

  
}, error => {

  return Promise.reject(error);
})





 export default request




 function comfirm () {

    
 }